// document.addEventListener('DOMContentLoaded', function() {
//   var pagetop = document.querySelector('.pagetop-icon');
//   if (!pagetop) return;

//   pagetop.addEventListener('click', function(e) {
//     e.preventDefault();
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function() {
  var pagetop = document.querySelector('.pagetop-icon');
  if (!pagetop) return; // .pagetop-icon が存在しない場合は処理を終了

  // スクロールイベント
  window.addEventListener('scroll', function() {
    var scrollTop = window.scrollY;

    // フェードイン・フェードアウト
    if (scrollTop > 500) {
      pagetop.style.opacity = '1';
      pagetop.style.visibility = 'visible';
      pagetop.style.transition = 'opacity 0.5s ease-in-out';
    } else {
      pagetop.style.opacity = '0';
      pagetop.style.visibility = 'hidden';
      pagetop.style.transition = 'opacity 0.5s ease-in-out';
    }
  });

  // スムーススクロール（ページトップへ）
  pagetop.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});